import { GetPublishedTracksResponse } from "../../proto/api_pb";
import { FractionalTransactionState } from "../../proto/api_pb";
import { GetTrackResponse } from "../../proto/api_pb";

export const handleGetPublishedTracksResponse: (
  response: GetPublishedTracksResponse
) => Promise<any> = async (response: GetPublishedTracksResponse) => {
  const res: GetTrackResponse[] = response.getTracksList();
  const trackNfts: any = [];
  res.forEach((el) => {
    const title = el?.getTrack()?.getTitle();
    const artist = el?.getTrack()?.getArtist();
    const description = el?.getTrack()?.getDescription();
    const image = el?.getTrack()?.getImageUrl();
    const genres = el?.getTrack()?.getSongMetadata()?.getGenre();
    const timestamp = el?.getTrack()?.getTimestamp();
    const contributors = el?.getTrack()?.getCollaboratorsList();
    const state = FractionalTransactionState.TRANSACTION_MINTED;
    const ownerId = el?.getTrack()?.getOwnerId();
    const id = el.getTrack()?.getId();
    const price = "0";
    const txnId = el?.getTrack()?.getId();
    const song = el?.getTrackVersion()?.getTrackUrl();
    trackNfts.push({
      txnId,
      id,
      title,
      artist,
      description,
      image,
      song,
      price,
      genres,
      timestamp,
      contributors,
      ownerId,
      state,
    });
  });
  return trackNfts;
};
